<template>
  <div>
    <Banner image="noche-1" />
    <v-container>
      <v-row>
        <v-col>
          <v-card max-width="344" class="mx-auto">
            <v-card-title class="card-header white--text">Ingresar</v-card-title>
            <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-text-field
                type="email"
                v-model="email"
                :rules="emailRules"
                label="E-mail"
                required
              ></v-text-field>
              <v-text-field
                type="password"
                v-model="password"
                :rules="passwordRules"
                label="Contraseña"
                required
                @keyup.enter="login"
              ></v-text-field>

              <div class="content-btn">
                <v-btn
                  :disabled="!valid"
                  class="mr-4"
                  @click="login"
                >
                  Ingresar
                </v-btn>
              </div>
              <v-alert type="error" class="mt-4" v-if="errors.length > 0">
                  {{errors}}
              </v-alert>
            </v-form>  
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Banner from '@/components/BannerBlog';
  export default {
    name:'login',
    components:{Banner},
    created(){
      if(localStorage.getItem('token') !== null){
        this.$router.push('/')
      }
    },
    data(){
      return {
        valid: true,
        password: '',
        passwordRules: [
          v => !!v || 'Contraseña es requerida',
        ],
        email: '',
        emailRules: [
          v => !!v || 'E-mail es requerido',
          v => /.+@.+\..+/.test(v) || 'E-mail debe ser valido',
        ],
        errors:''
      }
    },
    methods: {
      async login () {
        await this.axios.post(`${this.$store.state.baseURL}/api/auth`,{
          email:this.email,
          password:this.password
        })
          .then(res => { 
            if(res.status === 200){
              localStorage.setItem('token',res.data.token)
              this.$router.push('/admin')
              this.$store.state.showLogin=false
              this.$store.state.showAdmin=true
            }
          })
          .catch(err => {
            console.log(err);
             this.errors= 'El usuario o la contraseña son invalidos'
            setTimeout(() => {
              this.errors= ''
            }, 3000);
          })  
      }
    }
  }
</script>

<style lang="scss" scoped>
.card-header{
  background:#2F1640;
  justify-content:center;
}
.content-btn{
  display:flex;
  justify-content:flex-end;
  & button {
    border:1px solid #2F1640;
    color:#2F1640;
  }
  & button:disabled{
    border:none;
  }
}
</style>